import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { IPayerMasterItem, IPayerMasterList } from '../Infrastructure/Interfaces';

const PayerMasterInitialState: IPayerMasterList = {
    loading: true,
    payerMasterList: [],
  };
  
  const ItemInitialState: IPayerMasterItem = {
    payerMasterId: 0,
    payerName: '',
    payerID: '',
    isActive: true,
    createdBy: '',
    createdOn: '',
    modifiedBy: '',
    modifiedOn: '',
  }
  
  const PayerMasterItemSlice = createSlice({
    name:'PayerMasterItem',
    initialState:{value:ItemInitialState},
    reducers:{
        setPayerMasterItem:(state,action)=>{
            state.value = action.payload
        }
    }
  })
  
  export const fetchPayerMasterList = createAsyncThunk(
    'fetchPayerMasterList',
    async () => {
      //const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
      const baseurl = process.env.REACT_APP_RRD_OPTIMIZATION_BASE_URL as string;
  
          return axios
            .get(baseurl + '/Payer/get_allpayername', {
              headers: {
                Pragma: 'no-cache'
              },
            })
            .then(response => {
              if (response.data.success) {
                return response.data.result;
              }
            });
        }
  );
  
  const PayerMasterListSlice = createSlice({
    name: 'payermasterlist',
    initialState: PayerMasterInitialState,
    reducers: {},
    extraReducers: builder => {
      builder.addCase(fetchPayerMasterList.fulfilled, (state, action) => {
        state.loading = false;
        state.payerMasterList = action.payload;
      });
      builder.addCase(fetchPayerMasterList.pending, (state, action) => {
        state.loading = true;
      });
      builder.addCase(fetchPayerMasterList.rejected, (state, action) => {
        state.loading = false;
        state.payerMasterList = [];
      });
    },
  });
  
  export const PayerMasterReducer = PayerMasterListSlice.reducer;
  
  export const {setPayerMasterItem} = PayerMasterItemSlice.actions;
  
  export const PayerMasterItemReducer = PayerMasterItemSlice.reducer;